import React from 'react';
import useMountEffect from '@restart/hooks/useMountEffect';
import classNames from 'classnames/bind';
import moment from 'moment';
import { IoCheckmarkOutline } from 'react-icons/io5';

import { getOrderDisplayNo } from 'utils/CodeMapper';
import { phoneNumber } from 'utils/Formatter';

import styles from './PrintChecklist.module.scss';

const cx = classNames.bind(styles);

const Print = ({ checklist: data, order, close }) => {
  useMountEffect(() => {
    window.print();
    close();
  });

  return (
    <div className={cx('container')}>
      <div className={cx('paperWrapper')}>
        <div className={cx('paper')}>
          <div className={cx('printArea')}>
            <div className={cx('title')}>
              <div className={cx('docTitle')}>수시점검 내역서</div>
              <div className={cx('company')}>BTE inc.</div>
            </div>
            <div className={cx('orderInfo')}>
              <div className={cx('column')}>
                <div className={cx('rows')}>
                  <div className={cx('row')}>
                    <div className={cx('label')}>유형</div>
                    <div className={cx('value')}>: 주문</div>
                  </div>
                  <div className={cx('row')}>
                    <div className={cx('label')}>주문번호</div>
                    <div className={cx('value')}>: {getOrderDisplayNo(order)}</div>
                  </div>
                  <div className={cx('row')}>
                    <div className={cx('label')}>주문일자</div>
                    <div className={cx('value')}>: {moment(order.orderDate).format('YYYY-MM-DD')}</div>
                  </div>
                  <div className={cx('row')}>
                    <div className={cx('label')}>수량</div>
                    <div className={cx('value')}>: {order.quantity}</div>
                  </div>
                </div>
                <div className={cx('column')}>
                  <div className={cx('rows')}>
                    <div className={cx('row')}>
                      <div className={cx('label')}>주문자명</div>
                      <div className={cx('value')}>: {order.deliveryCompany}</div>
                    </div>
                    <div className={cx('row')}>
                      <div className={cx('label')}>전화번호</div>
                      <div className={cx('value')}>: {phoneNumber(order.deliveryPhone)}</div>
                    </div>
                    <div className={cx('row')}>
                      <div className={cx('label')}>수신자명</div>
                      <div className={cx('value')}>: {order.customerCompany}</div>
                    </div>
                    <div className={cx('row')}>
                      <div className={cx('label')}>전화번호</div>
                      <div className={cx('value')}>: {phoneNumber(order.customerPhone)}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={cx('checklist')}>
              <div className={cx('header')}>
                <div className={cx('term')}>항목</div>
                <div className={cx('answer')}>적합/부적합</div>
              </div>
              <div className={cx('rows')}>
                {data.checklist.map((item, index) => (
                  <div key={index} className={cx('row')}>
                    <div className={cx('term')}>{`${index + 1}. ${item.question}`}</div>
                    <div className={cx('answers')}>
                      {item.agreement ? (
                        <>
                          <IoCheckmarkOutline /> 적합
                        </>
                      ) : (
                        '부적합'
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className={cx('author')}>
              <div className={cx('rows')}>
                <div className={cx('row')}>
                  <div className={cx('label')}>점검자</div>
                  <div className={cx('value')}>: {data.createdBy}</div>
                </div>
                <div className={cx('row')}>
                  <div className={cx('label')}>점검일시</div>
                  <div className={cx('value')}>: {data.createdAt}</div>
                </div>
                <div className={cx('row')}>
                  <div className={cx(['label', 'signature'])}>
                    서명 <span>: </span>
                  </div>
                  <div className={cx(['value', 'signature'])}>
                    <img src={data.sign} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Print;
